module.exports = __webpack_public_path__ + "static/img/erweima_logo.1be112e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/erweima_logo.png
// module id = VdIR
// module chunks = 3